export default {"src":"/_next/static/media/logo.4afe8260.svg","height":227,"width":425};